import { components } from "@certn/legacy-api/generated-schemas/people";
import { endOfMonth, isAfter, parseISO, subYears } from "date-fns";

import { ValidationRuleType } from "./types";

export function requireEmploymentReferencesWithinXYearsRule(
  rule: components["schemas"]["RequireEmploymentReferencesWithinXYearsRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employment_references: components["schemas"]["EmploymentReferencesCheckFieldValue"]
    ) => {
      const references =
        employment_references?.references ?? employment_references;

      return references?.some((reference) => {
        // currently working at this company
        if (!reference.end_date) return true;

        return isAfter(
          new Date(endOfMonth(parseISO(reference.end_date))),
          subYears(new Date(), rule.value)
        );
      });
    },
  };
}
